import React from "react";
import { CourseInfo } from "./CourseInfo.jsx";

const MyCertificacions = (props) => {
  let myCourses = "";

  let myCoursesInEnglish = [
    {
        id: 8,
        title: "React from scratch",
        institution: "Udemy",
        date: "Current",
        credentialID: "-",
        "IDurl":
          "-",
      },
    {
      id: 7,
      title: "Professional Course of Git and GitHub",
      institution: "Platzi",
      date: "October 2021",
      credentialID: "daa7f278-ebc1-47a5-a149-673066e99ad3",
      "IDurl":
        "https://platzi.com/@carolinamoller13/curso/1557-git-github/diploma/detalle/",
    },
    {
      id: 6,
      title: "JavaScript Algorithms and Data Structures (300Hs)",
      institution: "freeCodeCamp",
      date: "October 2021",
      credentialID: "-",
      "IDurl":
        "https://freecodecamp.org/certification/caro_escala/javascript-algorithms-and-data-structures",
    },    {
        id: 5,
        title: "Scrum and Agile Case Studies: Scrum in real life practice",
        institution: "Udemy",
        date: "September 2021",
        credentialID: "UC-27bc0fa6-9f36-4874-bbc5-f4425e43a71b",
        "IDurl":
          "https://www.udemy.com/certificate/UC-27bc0fa6-9f36-4874-bbc5-f4425e43a71b/",
      },  {
        id: 4,
        title: "Course of Introduction to User Interface design (UI)",
        institution: "OpenWebinars",
        date: "July 2021",
        credentialID: "rMJZP",
        "IDurl":
          "https://openwebinars.net/cert/rMJZP",
      }, {
        id: 3,
        title: "Course of Advanced JavaScript",
        institution: "OpenWebinars",
        date: "July 2021",
        credentialID: "9W8OJ",
        "IDurl":
          "https://openwebinars.net/cert/9W8OJ",
      },{
        id: 2,
        title: "Responsive Web Design (300hs)",
        institution: "freeCodeCamp",
        date: "June 2021",
        credentialID: "-",
        "IDurl":
          "https://freecodecamp.org/certification/caro_escala/responsive-web-design",
      },{
        id: 1,
        title: "Fundaments of Project Management",
        institution: "LinkedIn",
        date: "May 2021",
        credentialID: "-",
        "IDurl":
          "https://www.linkedin.com/learning/fundamentos-de-la-gestion-de-proyectos",
      },
  ];

  let myCoursesInSpanish = [
    {
        id: 8,
        title: "React Desde Cero",
        institution: "Udemy",
        date: "Actualidad",
        credentialID: "-",
        "IDurl":
          "-",
      },
    {
      id: 7,
      title: "Curso Profesional de Git y GitHub",
      institution: "Platzi",
      date: "Octubre 2021",
      credentialID: "daa7f278-ebc1-47a5-a149-673066e99ad3",
      "IDurl":
        "https://platzi.com/@carolinamoller13/curso/1557-git-github/diploma/detalle/",
    },
    {
      id: 6,
      title: "Algoritmo de JavaScript y estructura de datos (300Hs)",
      institution: "freeCodeCamp",
      date: "Octubre 2021",
      credentialID: "-",
      "IDurl":
        "https://freecodecamp.org/certification/caro_escala/javascript-algorithms-and-data-structures",
    },    {
        id: 5,
        title: "Caso de estudio: práctica de metodologías Scrum y ágiles en la vida real",
        institution: "Udemy",
        date: "Septiembre 2021",
        credentialID: "UC-27bc0fa6-9f36-4874-bbc5-f4425e43a71b",
        "IDurl":
          "https://www.udemy.com/certificate/UC-27bc0fa6-9f36-4874-bbc5-f4425e43a71b/",
      },  {
        id: 4,
        title: "Curso de Introducción al diseño de interfaz de Usuarios (UI)",
        institution: "OpenWebinars",
        date: "Julio 2021",
        credentialID: "rMJZP",
        "IDurl":
          "https://openwebinars.net/cert/rMJZP",
      }, {
        id: 3,
        title: "Curso de JavaScript avanzado",
        institution: "OpenWebinars",
        date: "Julio 2021",
        credentialID: "9W8OJ",
        "IDurl":
          "https://openwebinars.net/cert/9W8OJ",
      },{
        id: 2,
        title: "Diseño web responsive (300hs)",
        institution: "freeCodeCamp",
        date: "Junio 2021",
        credentialID: "-",
        "IDurl":
          "https://freecodecamp.org/certification/caro_escala/responsive-web-design",
      },{
        id: 1,
        title: "Fundamentos de la gestión de proyectos",
        institution: "LinkedIn",
        date: "May 2021",
        credentialID: "-",
        "IDurl":
          "https://www.linkedin.com/learning/fundamentos-de-la-gestion-de-proyectos",
      },
  ];;

  if (props.language === "English") {
    myCourses = myCoursesInEnglish;
  } else if (props.language === "Spanish") {
    myCourses = myCoursesInSpanish;
  }

  return (
    <div id="Certif ">
      <div className="aboutMeContainer">
      <br></br>
        {/* cada proyecto */}
        {myCourses.map((course) => {
          return (
              <ul>
                  <li>
            <CourseInfo
              language={props.language}
              key={course.id}
              title={course.title}
              institution={course.institution}
              date={course.date}
              credentialID={course.credentialID}
              url={course.IDurl}
            />
                </li>
            </ul>
            
          );
        })}
          <br></br>
          <button
          id="closeButton"
          type="button"
          class="btn-close btn-close-white"
          aria-label="Close"
          onClick={props.closeCertif}
        ></button>
      </div>

    </div>
  );
};

export default MyCertificacions;
